// @ts-ignore
import React, { useEffect, useState } from "react"
import Select from "react-select"
import {

  getAllServices,
  getLineItemCharges,

} from "core/services/api"
import "../../MainBillingModule.scss"
import { useSelector } from "react-redux"
import RenderCommentParent from "../popover/RenderCommentParent"



// @ts-ignore
function TableRows({ rowsData, deleteTableRows, handleChange, invoice,
  handleReasonChange, autofillData, updateCostBasedQuantity, readOnly, updateEditableFields }: any) {

  //console.log(rowsData, "rows Data inside Table Rows");

  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  // @ts-ignore
  const [dropdownTypeService, setdropdownTypeService] = useState<any>([])
  useEffect(() => {
    getAllServices(userDetail?.currentCenter?.centerId).then((res: any) => {
      setdropdownTypeService(res);
    }).catch((err: any) => {
      console.log(err, "err");
    })
  }, [])

  const dropdownTreatment = dropdownTypeService?.map((values: any) => {
    return {
      label: values?.name,
      value: values?.id,
    }
  })

  //dropdown
  const discountType = [
    "CASH",
    "%",
  ]
  const discountDropdown = [
    { label: "CASH", value: "AMOUNT" },
    { label: "%", value: "PERCENTAGE" },
  ];

  const [costEntered, setCostEntered] = useState(false);
  //Popover comment Payment
  return rowsData?.map((data: any, index: any) => {
    const {
      treatmentAndDetails,
      serviceId,
      completedBy,
      cost,
      discount,
      charges,
      quantity,
      amountAfterDiscount,
      taxes,
      sacNumber,
      discountType,
      isEditable,
      reason,
      archive,
      isSuggestedConsultationCharges = false
    } = data
    let taxAmounts: { [key: string]: number } = {};
    taxes?.map((item: any) => {
      taxAmounts[item.name] = item.amount;
    });

    let {
      CGST: cgstAmount,
      SGST: sgstAmount,
      GST: gstAmount,
      IGST: igstAmount
    } = taxAmounts;

    const cgstPercentage = taxes?.find((item: any) => item.name === "CGST")?.percentage;
    const sgstPercentage = taxes?.find((item: any) => item.name === "SGST")?.percentage;
    const gstPercentage = taxes?.find((item: any) => item.name === "GST")?.percentage;
    const igstPercentage = taxes?.find((item: any) => item.name === "IGST")?.percentage;


    const customStyles = {
      control: (provided: any, state: any) => ({
        ...provided,
        opacity: state.isDisabled ? 1 : 1,
        backgroundColor: state.isDisabled ? "white" : "white",
        cursor: state.isDisabled ? "not-allowed" : "pointer",
        border: "1px solid #ccd0e7",
        borderRadius: "10px"
      }),
      dropdownIndicator: (provided: any, state: any) => ({
        ...provided,
        paddingRight: '0px', // reduce the padding of the right side of the arrow
        paddingLeft: '0px', // reduce the padding of the left side of the arrow
      }),
    };



    return (
      <>
        {!archive ? <>
          <tr key={index} className={`treatments-input-wrapper ${isSuggestedConsultationCharges ? "border border-warning" : ""}`}>
            <td style={{ width: '20%' }}>
              <Select
                name="treatmentAndDetails"
                className="treaments"
                defaultValue={{
                  label: treatmentAndDetails,
                  value: '',
                }}
                styles={customStyles}
                options={
                  dropdownTreatment.some((option: any) => option.label === treatmentAndDetails)
                    ? dropdownTreatment
                    : [
                      { label: treatmentAndDetails, value: serviceId },
                      ...dropdownTreatment
                    ]
                }
                isDisabled={readOnly}
                value={[
                  { label: treatmentAndDetails, value: serviceId },
                  ...dropdownTreatment.filter(
                    ({ label }: any) => label === treatmentAndDetails
                  ),
                ]}
                onChange={(data: any) => {
                  const serviceId = data?.value;
                  const invoiceId = invoice?.id;
                  getLineItemCharges(invoiceId, serviceId)
                    .then((res: any) => {
                      autofillData(res, data, index);
                    })
                    .catch((error: any) => {
                      console.log(error);
                    });
                }}
              />
              <div className="sac-no">SAC-{sacNumber}</div>
            </td>

            <td>
              <RenderCommentParent
                index={index}
                rowsData={rowsData}
                reason={reason}
                readOnly={readOnly}
                handleReason={(remarks: any, index: any) => {
                  handleReasonChange(remarks, index);
                }}
              />
            </td>
            <td style={{ width: '12%' }}>
              <input
                type="text"
                value={completedBy}
                onChange={(evnt) => handleChange(index, evnt)}
                name="completedBy"
                disabled={readOnly ? true : false}
                className="form-control"
              />{" "}
            </td>
            <td style={{ width: '7%', minWidth: '90px' }}>
              <input
                type="number"
                inputMode="numeric"
                value={cost}
                onChange={(evnt) => {
                  // handleChange(index, evnt)
                  const newCostValue = evnt.target.value;
                  updateEditableFields(index, evnt)
                  setCostEntered(newCostValue !== "");
                }
                }
                name="cost"
                disabled={readOnly ? true : !isEditable}
                className="form-control"
              />{" "}
            </td>
            <td style={{ width: '5%' }}>
              <input
                type="text"
                placeholder="0"
                value={discount}
                onChange={(evnt) => {
                  const value = Number(evnt?.target?.value);
                  if (charges >= value) {
                    if (discountType === "PERCENTAGE") {
                      if (value >= 0 && value <= 100) {
                        handleChange(index, evnt);
                        updateEditableFields(index, evnt);
                      }
                    } else {
                      handleChange(index, evnt);
                      updateEditableFields(index, evnt);
                    }
                  }
                }}
                name="discount"
                disabled={!cost || (readOnly ? true : !isEditable)}
                className="form-control"
              />{" "}
            </td>
            <td style={{ width: '7%' }}>
              <Select
                className="select-payment"
                name="modeOfPayment"
                value={discountDropdown?.filter((item: any) => item?.value === discountType)}
                styles={customStyles}
                isDisabled={!cost || (readOnly ? true : !isEditable)}
                options={discountDropdown}
                onChange={(evnt) => {
                  //handleChange(index, evnt)
                  updateEditableFields(index, evnt)
                }}
              />
            </td>
            <td style={{ width: '6%' }}>
              <input
                type="text"
                value={quantity}
                disabled={readOnly ? true : false}
                onChange={(evnt) => {
                  updateCostBasedQuantity(index, evnt)
                  updateEditableFields(index, evnt);
                }}
                name="quantity"
                className="form-control"
              />{" "}
            </td>
            <td style={{ width: '8%' }}>
              <input
                type="text"
                value={amountAfterDiscount}
                disabled={true}
                //disabled={readOnly ? true : !isEditable}
                onChange={(evnt) => handleChange(index, evnt)}
                name="amountAfterDiscount"
                className="form-control"
              />{" "}
            </td>
            {/* <td style={{ width: '7%' }}>
              <input
                type="number"
                value={gstAmount}
                title={`${gstAmount}`}
                //disabled={readOnly ? true : !isEditable}
                disabled={!cost || (readOnly ? true : !isEditable)}
                onChange={(evnt) => {
                  //handleChange(index, evnt)
                  updateEditableFields(index, evnt)
                }}
                name="GST"
                className="form-control"
              />{" "}
              <div className="sgst-percent"> @{gstPercentage}%</div>
            </td> */}
            <td style={{ width: '7%' }}>
              <input
                type="number"
                value={cgstAmount}
                title={`${cgstAmount}`}
                disabled={!cost || (readOnly ? true : !isEditable)}
                onChange={(evnt) => {
                  // handleChange(index, evnt)
                  // console.log("entered cgst--->", evnt.target.value)
                  updateEditableFields(index, evnt)
                }
                }
                name="CGST"
                className="form-control"
              />{" "}
              <div className="sgst-percent"> @{cgstPercentage}%</div>
            </td>
            <td style={{ width: '7%' }}>
              <input
                type="number"
                title={` ${sgstAmount}`}
                value={sgstAmount}
                disabled={!cost || (readOnly ? true : !isEditable)}
                onChange={(evnt) => {

                  //handleChange(index, evnt)
                  updateEditableFields(index, evnt)
                }
                }
                name="SGST"
                className="form-control"
              />{" "}
              <div className="sgst-percent">@{sgstPercentage}%</div>
            </td>
            <td style={{ width: '7%' }}>
              <input
                type="number"
                value={igstAmount}
                title={` ${igstAmount}`}
                disabled={!cost || (readOnly ? true : !isEditable)}
                onChange={(evnt) => {
                  //handleChange(index, evnt)
                  console.log("evnt-------->", evnt)
                  updateEditableFields(index, evnt)

                }}
                name="IGST"
                className="form-control"
              />{" "}
              <div className="sgst-percent"> @{igstPercentage}%</div>
            </td>

            <td style={{ width: '8%' }}>
              <input
                type="text"
                value={charges}
                onChange={(evnt) => {
                  console.log("evnt-------->", evnt)
                  handleChange(index, evnt)
                }}
                name="charges"
                disabled={true}
                className="form-control"
              />{" "}
            </td>

            <td>
              <button
                style={{ height: '27px', marginTop: '5px', paddingTop: '1px' }}
                className="btn btn-outline-danger"
                onClick={() => deleteTableRows(index)}
              >
                x
              </button>
            </td>
          </tr>
        </> : <></>}

      </>
    )
  })
}
export default TableRows

